
<template>
    <div class="row">
        <PatientHeader :patient="patient" :carehomeid="carehomeid"></PatientHeader>
        <div class="col-sm-12">
            <router-view></router-view>
        </div>
    </div>
</template>



<script>
    import PatientHeader from "../../appcontrols/patientHeader/patientHeader.scp.html"
    import Dal from "./../../../scripts/dataaccess"


    export default {
        props: ['patientid', 'carehomeid'],
        data: function () {
            return {
                patient: {},
                wardid : null
            }
        },
        mounted: function () {
            var dal = new Dal();
            var that = this;
            dal.GetPatient(this.patientid).then(data => {
                that.patient = data;
            });

        },
        components: {
            PatientHeader
        }
    }

</script>


// WEBPACK FOOTER //
// patient.scp.html?448c5b3d